import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

interface LetContext<T> {
    efLet: T;
}

@Directive({
    selector: '[efLet]',
    standalone: false
})
export class LetDirective<T> {
    private _context: LetContext<T> = { efLet: null };

    constructor(
        _viewContainer: ViewContainerRef,
        _templateRef: TemplateRef<LetContext<T>>
    ) {
        _viewContainer.createEmbeddedView(_templateRef, this._context);
    }

    @Input()
    set efLet(value: T) {
        this._context.efLet = value;
    }
}
